import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render/index";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getCorePopUpStore from "../../../stores/core/core-popup-store";

import SupervisedAuditEventsData from "./supervised-audit-events-data";
import SupervisedEventsForm from "./supervised-events-form";
import ET3PageDiv from "../../../core/et3-page-div";

const SupervisedEvents = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "SUPERVISOR_SUPERVISED_EVENTS",
      "SUPERVISOR_SUPERVISED_EVENTS"
    );
  }, []);
  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("SUPERVISE")}
        subTitle={i18n.get("VIEW_SUPERVISED_EVENTS")}
        withRefresh={false}
        withHelper={true}
        onPress={() => {
          getCorePopUpStore().showHelperMessage("Supervise_Events_Helper_Text");
        }}
      />
      <SupervisedEventsForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <SupervisedAuditEventsData />
    </ET3PageDiv>
  );
});
export default SupervisedEvents;
